import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Pagination } from '@core/models/pagination.model';
import { Subscription } from 'rxjs';
import { PwaUsageDataService } from '../../services/pwa-usage-data.service';

/**
 * AIO-81798 — everything we hold on one member's PWA usage.
 *
 * The listing collapses a member into a single row, which hides the two things an operator
 * asks about when a figure looks wrong: which devices are behind that row, and what the
 * member actually did. Both are read straight from pwa_usages / pwa_activity_logs.
 */
@Component({
  selector: 'kt-pwa-member-details',
  templateUrl: './pwa-member-details.component.html',
  styleUrls: ['./pwa-member-details.component.scss']
})
export class PwaMemberDetailsComponent implements OnInit, OnDestroy {

  member: any = null;
  devices: any[] = [];
  activities: any[] = [];

  pagination: Pagination;
  pageSize = 30;
  page = 1;
  maxSize = 5;

  loading = false;

  /** The request for the page on screen. A newer page cancels it - see load(). */
  private request: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { memberId: number, username: string },
    public dialogRef: MatDialogRef<PwaMemberDetailsComponent>,
    private pwaUsageDataService: PwaUsageDataService
  ) { }

  ngOnInit() {
    this.load();
  }

  /** Only the activity table pages; the device list is small and always returned whole. */
  load(page = 1) {
    this.loading = true;
    this.page = page;

    /* AIO-83768: cancel the page still loading. Two quick clicks used to leave both requests
       running, and if the earlier one answered last the table showed its rows under the later
       page number. */
    this.request?.unsubscribe();

    this.request = this.pwaUsageDataService.getMemberDetail(this.data.memberId, `?page=${page}&perPage=${this.pageSize}`).subscribe({
      next: (res: any) => {
        this.member = res.member;
        this.devices = res.devices ?? [];
        this.activities = res.activities?.rows ?? [];
        this.pagination = res.activities?.paginations;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  ngOnDestroy() {
    this.request?.unsubscribe();
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

}
